import PARENT from '../types.js';

const SALT_MODE = `${PARENT}/SALT_MODE`;

export const SET_SALT_MODE = `${SALT_MODE}/SET`;
